import { render, staticRenderFns } from "./CreateEditProject.vue?vue&type=template&id=12b1666a&scoped=true"
import script from "./CreateEditProject.vue?vue&type=script&lang=js"
export * from "./CreateEditProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b1666a",
  null
  
)

export default component.exports